import { ICustomer } from "../entities-generated/common/customer";
import { IUpdateCustomerRequest } from "../entities-generated/models/project/update-customer-request";
import { ApiClient } from "./admin-api-client";

class CustomerApiClientClass {
  public getCustomer(projectId: string) {
    return ApiClient.get<ICustomer>(`projects/${projectId.replace('.', '-')}/customer`);
  }

  public updateCustomer(request: IUpdateCustomerRequest, projectId: string) {
    return ApiClient.patch<void>(`projects/${projectId.replace('.', '-')}/customer`, request);
  }
}

export const CustomerApiClient = new CustomerApiClientClass();